/** @flow */

export const managementMessages = {
  en: {
    CALL_SCRIPT_UPDATED: "Call Script was successfully updated",
    MEDICAL_TRIAGE_SCRIPT_UPDATED: "Medical Triage Script was successfully updated",
    MEDICAL_TRIAGE_NOTE_UPDATED: "Medical Triage Symptom Guidance Note was successfully updated",
    CALLBACK_QUEUE_UPDATED: "Callback Queue was successfully updated",
    HEALTH_NOTICE_CREATED: "Health Notice was successfully created",
    HEALTH_NOTICE_UPDATED: "Health Notice was successfully updated",
    HEALTH_NOTICE_DELETED: "Health Notice was successfully deleted",
    HEALTH_NOTICE_PUBLISHED: "Health Notice was successfully published",
    HEALTH_NOTICE_CANCELLED: "Health Notice was successfully cancelled",
    IMAGE_UPLOADED: "Image was successfully uploaded",
    ALLERGY_CREATED: "Allergy was successfully created",
    ALLERGY_UPDATED: "Allergy was successfully updated",
    CONDITION_CREATED: "Condition was successfully created",
    CONDITION_UPDATED: "Condition was successfully updated",
    MEDICATION_CREATED: "Medication was successfully created",
    MEDICATION_UPDATED: "Medication was successfully updated",
    VACCINATION_CREATED: "Vaccination was successfully created",
    VACCINATION_UPDATED: "Vaccination was successfully updated",
    PROVIDER_CREATED: "Provider was successfully created",
    PROVIDER_UPDATED: "Provider was successfully updated",
    SERVICE_TYPE_CREATED: "Service Type was successfully created",
    SERVICE_TYPE_UPDATED: "Service Type was successfully updated",
    CARE_PLAN_CREATED: "Care Plan was successfully created",
    CARE_PLAN_UPDATED: "Care Plan was successfully updated",
    SUPPORT_PLAN_CREATED: "Support Plan was successfully created",
    SUPPORT_PLAN_UPDATED: "Support Plan was successfully updated",
    TRIAGE_QUESTION_CREATED: "Triage Question was successfully created",
    TRIAGE_QUESTION_UPDATED: "Triage Question was successfully updated",
    TRIAGE_ADVICE_CREATED: "Triage Advice was successfully created",
    TRIAGE_ADVICE_UPDATED: "Triage Advice was successfully updated",
  },
};

export default {
  en: {
    MANAGEMENT: "Management",
    CONTACT_CENTRE_MANAGEMENT: "Contact Centre",
    CLINICAL_GOVERNANCE: "Clinical Governance",
    INCIDENT_RATE_REPORT: "Incident Rate Report",
    CONTACT_CENTRE_MANAGEMENT_DESCRIPTION:
      "View the contact centre dashboard, search for a specific advisor, manage callback queues and update call handling scripts.",
    MANAGEMENT_GET_STARTED: "Get Started",
    MANAGEMENT_DASHBOARD: "Dashboard",
    MANAGEMENT_DASHBOARD_DESCRIPTION:
      "Here you can see a real-time summary of inbound and outbound interactions handled today in the contact centre.",

    MANAGEMENT_ADVISORS: "Advisors",
    MANAGEMENT_ADVISORS_DESCRIPTION:
      "Here you can view the details performance and recent activities of a chosen nurse or absence advisor",

    MANAGEMENT_CALLBACKS: "Callbacks",
    MANAGEMENT_CALLBACKS_DESCRIPTION:
      "Here you can view the Callback Queues and create, cancel, restore, reschedule and review completed callbacks.",

    MANAGEMENT_RATES: "Rates",
    MANAGEMENT_RATES_DESCRIPTION:
      "Here you Set the rate of permitted Scheduled callbacks by time of day and day of the week.",

    MANAGEMENT_SCRIPTS: "Scripts",
    MANAGEMENT_SCRIPTS_DESCRIPTION:
      "Here you can administer all of the master callflow scripts, medical triage reminders and symptom guidance notes.",

    MANAGEMENT_USERS_TITLE: "Users",
    MANAGEMENT_MESSAGES_TITLE: "Messages",
    SYSTEM_TESTS: "System Tests",
    SUBJECT_LINE: "Subject Line",
    BODY_OF_EMAIL: "Body of Email",
    SEND_TEST_EMAIL: "Send Test Email",
    SEND_TEST_SMS: "Send Test SMS",
    ORIGINATOR: "Originator",
    UNIQUE_MESSAGE_BODY: "Unique Message Body",

    SYSTEM_MANAGEMENT: "System",
    SYSTEM_MANAGEMENT_DESCRIPTION:
      "Administer various system settings, as well as user accounts. System settings that can be managed here include training content, service admin options and system messages that are displayed to users upon login.",
    SYSTEM_MANAGEMENT_SEARCH_FOR_A_USER: "Search for a User",
    SYSTEM_MANAGEMENT_SERVICE_OPTIONS: "Service Options",
    SYSTEM_MANAGEMENT_MANAGE_TRANING_MATERIAL: "Manage Traning Material",
    SYSTEM: "System",
    // Nav
    USER_MANAGEMENT: "User Management",
    SERVICE_ADMIN_MANAGEMENT: "Service Admin Management",
    TOOLTIP_MANAGEMENT: "Tooltip Management",
    TRAINING_MANAGEMENT: "Training Management",
    GLOSSARY: "Glossary",
    FAQ_CONTENT: "FAQ Content",
    SYSTEM_MESSAGES: "System Messages",
    RESELLER_REGISTRATIONS: "Reseller Registrations",

    USER_ID: "User ID",
    USER_TYPE: "User Type",
    EDIT_USER: "Edit User",
    ADD_NEW_USER: "Add New User",
    SEARCH_BY_USERNAME: "Search By Username",
    CONFIGURE_USER: "Configure User",
    ADVISOR_ADMIN: "Advisor Admin",
    ADVISOR_PROFILE: "Advisor Profile",
    ADVISOR_DETAILS: "Advisor Details",
    PERFORMANCE_SUMMARY: "Performance Summary",
    ADVISOR_ACTIVITY: "Advisor Activity",
    CALLBACK_ADMIN: "Callback Admin",
    QUEUE_MANAGEMENT: "Queue Management",
    QUEUE_ADMIN: "Queue Admin",
    SCRIPT_MANAGEMENT: "Script Management",
    SCRIPT_ADMIN: "Script Admin",
    SERVICEDESK_ADMIN: "Servicedesk Admin",
    NOTICES_ADMIN: "Notices Admin",
    INCIDENT_RATES: "Incident Rates",
    ACCESS_TYPE: "Access Type",
    SEARCH_BY_SURNAME_OR_USER_ID: "Search by Surname or User ID",
    USER_DETAILS: "User Details",
    JOB_TITLE: "Job Title",
    HOMEWORKING_USER: "Homeworking User",
    FCA_BLOCK: "FCA Block",
    INB_REGISTERED: "INB Registered",
    PHONE_LOGIN: "Phone Login",
    YES: "Yes",
    No: "No",
    HOUR: "Hour",
    RATE: "Rate",
    SUNDAY: "Sunday",
    MONDAY: "Monday",
    TUESDAY: "Tuesday",
    WEDNESDAY: "Wednesday",
    THURSDAY: "Thursday",
    FRIDAY: "Friday",
    SATURDAY: "Saturday",
    TOTAL_LOGINS: "Total Logins",
    VIEW_RECORD: "View Record",
    TOTAL_INTERACTIONS: "Total Interactions",
    INBOUND_ABSENCE_STARTS: "Inbound: Absence Starts",
    INBOUND_ABSENCE_UPDATES: "Inbound: Absence Updates",
    INBOUND_ABSENCE_CLOSES: "Inbound: Absence Closes",
    TOTAL_AUTO_CALLBACKS: "Total Auto Callbacks",
    TOTAL_ASAP_CALLBACKS: "Total ASAP Callbacks",
    TOTAL_SCHEDULED_CALLBACKS: "Total Scheduled Callbacks",
    TOTAL_ADVICE_CALLBACKS: "Total Advice Callbacks",
    INTERACTION_ID: "Interaction ID",
    LOGIN_SCREEN: "Login Screen",
    LOGIN_SCREEN_TEXT: "Login Screen Text",
    RELEASE_NAME: "Release Name",
    EDIT_LOGIN_MESSAGE: "Edit Login Message",
    FILE: "File",
    EDIT_RELEASE_NOTE: "Edit Release Note",
    ALLOW_ONLY_PDF_FILES: "Allowed PDF files only!",
    QUEUE_ADMIN_INFORMATION:
      "This page is used to control how many Scheduled Callbacks can be booked into each 2-hour period of the day. You can either apply bulk settings to an entire day, or specific settings to each individual block of time. The goal is to ensure that users cannot book more callbacks than we have Nurse resource available to deliver.",
    SCRIPT_ADMIN_INFORMATION:
      "These are generic scripts that appear in the absence interaction screen. They appear for all absences for all clients. They are designed to prompt GoodShape’s call handlers to pass on an important message or double check an information piece of information. These scripts do not appear in the GoodShape app.",
    CALLBACKS_INFORMATION:
      "A callback is when a client employee books an appointment with a member of GoodShape’s clinical team. Scheduled Callbacks must take place within 2 hours of the agreed time and are related to an employee’s absence. Medical Advice Callbacks are not related to an absence and have no SLA measure.",
    SETTING_THE_SCENE_INFO:
      "- Current Symptoms, Duration and Severity\n- Treatment and its Effectiveness\n- Medical Professional Input",

    PERFORMANCE_MEASURE: "Performance Measure",
    CONTACT_CENTRE_DASHBOARD: "Contact Centre Dashboard",
    KEY_PERFORMANCE_INDICATORS: "Key Performance Indicators",
    CLIENT_SUMMARY: "Client Summary",
    USER_SUMMARY: "User Summary",
    TODAY: "Today",
    LAST_7_DAYS: "Last 7 Days",
    LAST_30_DAYS: "Last 30 Days",
    CALLS: "Calls",
    INCOMING_INTERACTIONS: "Incoming Interactions",
    ASAP_CALLBACKS: "ASAP Callbacks",
    SCHEDULED_CALLBACK: "Scheduled Callback",
    SCHEDULED_CALLBACKS: "Scheduled Callbacks",
    SCHEDULED_CALLBACKS_WITHIN_SLA: "Scheduled: Within SLA",
    SCHEDULED_CALLBACKS_OUTSIDE_SLA: "Scheduled: Outside SLA",
    MEDICAL_ADVICE_CALLBACKS: "Medical Advice Callbacks",
    MEDICAL_ADVICE_ONLY: "Medical Advice Only",
    AUTO_CALLBACKS: "AUTO Callbacks",
    TOTAL_INBOUND_INTERACTIONS: "Total Inbound Interactions",
    AVG_ASAP_TIME: "Avg. ASAP Time",
    SCHEDULED_SLA: "Scheduled SLA %",
    TOTAL_CALLBACKS: "Total Callbacks",
    OVERFLOW_INTERACTIONS: "Overflow Interactions",
    TOTAL_OUTBOUND_CALLS: "Total Outbound Calls",
    CURRENT_STATUS: "Current Status",
    HEADLINES: "Headlines",
    DASHBOARD_INFORMATION:
      "This dashboard provided a summary of activity that has been completed on GoodShapeHealth. Headline total are available to provide a quick overview of the total inbound interactions, scheduled callbacks, SLA performance and the number of interactions that were processed by Overflow. A client summary and user summary table is also provided.",
    //Types:
    ADMIN: "Admin",
    SERVICE_MANAGER: "Service Manager",
    ABSENCE_ADVISOR: "Absence Advisor",
    THIRD_PARTY_APPLICATION: "Third Party Application",
    NURSE_ADVISOR: "Nurse Advisor",
    LEAD_NURSE_ADVISOR: "Lead Nurse Advisor",
    SERVICE_DELIVERY_ADVISOR: "Service Delivery Advisor",
    CLIENT_ADMIN: "Client admin",
    CLIENT_FULL_ACCESS: "Full Access",
    FULL_HR_ACCESS: "Full Access",
    CLIENT_BASIC_ACCESS: "Client Basic Access",
    CLIENT_DATA_TRANSFER: "Data Transfer",
    CLIENT_TREND_VIEWER: "Trend Viewer",
    CONTACT_CENTRE_MANAGER: "Contact Centre Manager",
    SUPPORT_CONTRACT_MANAGER: "Support Account Manager",

    INTERACTION_TYPE: "Interaction Type",
    INBOUND: "Inbound",
    TRANSFER: "Transfer",
    CALLBACK: "Callback",
    TEXT_TO_CLOSE_SERVICE: "Text to close service",

    // Queue Management
    EDIT_QUEUE: "Edit Queue",
    EDIT_CALLBACK_QUEUE: "Edit Callback Queue",
    CALLBACK_QUEUE: "Callback Queue",
    SPECIFY_RATES_IN_BULK: "Specify Rates in Bulk",
    SPECIFY_RATES: "Specify Rates",
    SELECT_DAYS: "Select days",

    // Script Management
    MEDICAL_TRIAGE_SCRIPTS: "Medical Triage Scripts",
    MEDICAL_SCRIPT: "Medical Script",
    SCRIPT_TEXT: "Script Text",
    INSTRUCTION_TEXT: "Instruction Text",
    CALL_FLOW_SCRIPTS_INSTRUCTIONS: "Callflow Scripts and Instructions",
    MASTER_SCRIPTS: "Master Scripts",
    TRIAGE_SCRIPTS: "Triage Scripts",
    EDIT_SCRIPT_TITLE: "Edit {scriptType} Script",
    SYMPTOM_NAME: "Symptom Name",
    GUIDANCE_NOTES: "Guidance Notes",
    EDIT_MEDICAL_TRIAGE_SYMPTOM_GUIDE_NOTE: "Edit Medical Triage Symptom Guide Note",

    // Callback Admin
    ACTIVE_QUEUE: "Active Queue",
    CALLBACKS_TYPE: "{callbackName} Callback",
    TOTAL_COUNT_INSIDE_SLA: "{total} Inside SLA",
    TOTAL_COUNT_OUTSIDE_SLA: "{total} Outside SLA",
    AUTO: "Auto",
    ASAP: "ASAP",
    SCHEDULED: "Scheduled",
    MEDICAL_ADVICE: "Medical Advice",
    CALLBACK_TYPE: "Callback Type",
    SLA_STATUS: "SLA Status",
    CREATE_CALLBACK: "Create Callback",
    CALLBACK_ID: "Callback ID",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    CLIENT_NAME: "Client Name",
    STATUS: "Status",
    DUE_DATE: "Due Date",
    PHONE_NUMBER: "Phone Number",
    RESCHEDULE: "Reschedule",
    REMOVE_CALLBACK: "Remove Callback",
    COUNT_OF_RECORDS_SELECTED: "{count} record(s) selected",
    COMPLETED_ARCHIVE: "Completed Archive",
    TYPE_TO_SEARCH: "Type To Search...",
    DATE_FROM: "Date From",
    DATE_COMPLETED: "Date Completed",
    ADVISOR_NAME: "Advisor Name",
    RESTORE: "Restore",
    CALLBACK_RESTORED: "Callback was successfully restored!",
    OFFSET_CALLBACK_BY: "Offset callback by",
    HOURS: "Hours",
    ADD_CALLBACK: "Add Callback",
    SELECT_CLIENT_AND_EMPLOYEE: "Select Client & Employee",
    SELECT_CLIENT: "Select Client",
    SEARCH_EMPLOYEES_BY_SURNAME: "Search Employees by Surname",
    SEARCH_EMPLOYEES: "Search Employees",
    EMPLOYEE_REF: "Employee Ref.",
    SURNAME: "Surname",
    CALLBACK_DETAILS: "Callback Details",
    OVERDUE: "Overdue",
    PENDING: "Pending",
    CALLBACK_TIME: "Callback Time",
    SUCCESS_WITHIN_SLA: "Success within sla",
    FROM_DATE: "From Date",
    TO_DATE: "To Date",
    USER_WAS_SUCCESSFULLY_CREATED: "User was successfully created",
    USER_WAS_SUCCESSFULLY_UPDATED: "User was successfully updated",
    CALL_FLOW_STEP: "Call flow Step",
    CLINICAL_INCIDENT_REGISTER: "Clinical Incident Register",
    INCIDENT_REGISTER: "Incident Register",
    LOG_NEW_INCIDENT: "Log New Incident",
    SELECT_CLIENT_EMPLOYEE: "Select Client & Employee",
    STEP_SELECT_CLIENT_EMPLOYEE: "Step 1: Select Client & Employee ",
    STEP_LOG_INCIDENT_DETAILS: "Step 2: Log Incident Details",
    INCIDENT_RATES_REPORT: "Incident Rates Report",
    NURSE_INTERACTION: "Nurse Interaction",
    CLINICAL_INCIDENT: "Clinical Incident",
    TOTAL_CLINICAL_INCIDENTS: "Total Clinical Incident",
    TOTAL_NURSE_INTERACTIONS: "Total Nurse Interactions",
    TOTAL_OF_CLINICAL_INCIDENT: "Total % Of Clinical Incident",
    MOST_COMMON_CAUSE: "Most Common Cause",
    CLINICAL_INCIDENT_BY_MONTH: "Clinical Incident By Month",
    CLINICAL_INCIDENT_BY_REASON: "Clinical Incident By Reason",
    INCIDENT_ID: "Incident ID",
    INCIDENT_DATE: "Incident Date",
    CALL_HANDLER: "Call Handler",
    CAUSE: "Cause",
    INCIDENT_TYPE: "Incident Type",
    INCIDENT_CAUSE: "Incident Cause",
    PRIORITY: "Priority",
    TOTAL_NI: "Total NI",
    CI_RATE: "CI Rate",

    // SERVICE DESK
    SERVICE_DESK_MANAGEMENT: "Service Desk Management",
    DEFAULT_SETTINGS: "Default Settings",
    DEFAULT_PROJECT: "Default Project",
    DEFAULT_TICKET_STATUS: "Default Ticket Status",
    FINAL_TICKET_STATUS: "Final Ticket Status",
    TICKET_STATUS_ERROR: "Should not be equal to Final Ticket Status",
    YOU_SURE_WANT_DELETE_CLINICAL_INCIDENT: `Are you sure you want to delete that <strong>{incidentPriority}</strong> priority <strong>{incidentType}</strong> incident?`,
    NO_KEEP_IT: "No, keep it",
    YES_DELETE_IT: "Yes, delete it",

    // HEALTH NOTICES
    HEALTH_NOTICES: "Health Notices",
    HEALTH_NOTICE: "Health Notice",
    ID: "ID",
    VIEWS: "Views",
    AUTHOR: "Author",
    WARNING: "Warning",
    ADVICE: "Advice",
    SUGGESTION: "Suggestion",
    PUBLISHED: "Published",
    NEWS: "News",
    DELETE_NOTICE: "Delete Notice #{id}",
    YOU_SURE_WANT_DELETE_HEALTH_NOTICE: `Are you sure you want to delete health notice - <strong>{name}</strong>?`,
    LOGIN_SUCCESS_RATE: "Login Success Rate",

    // IMAGE LIBRARY
    CLINICAL_ADMIN: "Clinical Admin",
    IMAGE_LIBRARY: "Image Library",
    IMAGE_LIBRARY_INFO:
      "This is the list of authorised images that can be selected and used for clinical content, such as care plan activities and health notices. Any images added here become available for users to select from when performing admin elsewhere in GoodShape Health.",
    IMAGES: "Images",
    SEARCH_IMAGES: "Search Images...",
    NO_IMAGES: "No images have been uploaded yet",
    NO_IMAGES_FOUND: "No images found matching your search",
    SELECT_IMAGE: "Select Image",
    CHANGE_IMAGE: "Change Image",
    ADD: "Add",
    ADD_NEW_IMAGE: "Add New Image",
    IMAGE_FILE: "Image",
    INVALID_IMAGE_FILE_TYPE: "Only JPEG and PNG files are allowed",
    // Classifications
    CLASSIFICATIONS: "Classifications",
    ALLERGIES: "Allergies",
    CONDITIONS: "Conditions",
    ADD_ALLERGY: "Add Allergy",
    EDIT_ALLERGY: "Edit Allergy",
    EDIT_ALLERGY_WITH_ID: "Edit Allergy ID {id}",
    ALLERGIES_INFO:
      "This is the list of allergies that employees can select from when completing their GoodShape profile. Selected allergies appear in the employee’s record and are shown to the GoodShape clinical team during triage assessments.",
    CONDITION: "Condition",
    ADD_CONDITION: "Add Condition",
    EDIT_CONDITION: "Edit Condition",
    EDIT_CONDITION_WITH_ID: "Edit Condition ID {id}",
    KEYWORD: "Keyword",
    CONDITIONS_INFO:
      "This is the list of medical conditions that employees can select from when completing their GoodShape profile. Selected conditions will appear in the employee’s record and are shown to the GoodShape clinical team during triage assessments. They are also used in the aggregated Workforce Health report.",
    MEDICATION_NAME: "Medication Name",
    ADD_MEDICATION: "Add Medication",
    EDIT_MEDICATION: "Edit Medication",
    EDIT_MEDICATION_WITH_ID: "Edit Medication ID {id}",
    MEDICATIONS_INFO:
      "This is the list of medications that employees can select from when completing their GoodShape profile. Selected medications will appear in the employee’s record and are shown to the GoodShape clinical team during triage assessments. They are also used in the aggregated Workforce Health report.",
    EDIT_VACCINATION_WITH_ID: "Edit Vaccination ID {id}",
    VACCINATIONS_INFO:
      "This is the list of vaccinations that employees can select from when completing their GoodShape profile. Selected vaccinations appear in the employee’s record and are shown to the GoodShape clinical team during triage assessments.",
    PROVIDERS: "Providers",
    PROVIDER: "Provider",
    ADD_PROVIDER: "Add Provider",
    EDIT_PROVIDER_WITH_ID: "Edit Provider ID {id}",
    CLIENTS: "Clients",
    PROVIDERS_INFO:
      "This list controls the providers that can be selected when adding a new Wellbeing Service to a client via the Services tab in the Admin Console on GoodShapeCentral. These services appear in the Services Hub for employees to see. Please ensure that only reputable and trustworthy providers are added to this list.",
    SERVICE_TYPES: "Service Types",
    ADD_SERVICE_TYPE: "Add Service Type",
    EDIT_SERVICE_TYPE_WITH_ID: "Edit Service Type ID {id}",
    PARENT_CATEGORY: "Parent Category",
    SERVICE_TYPES_INFO:
      "This list controls the Service Types that wellbeing providers can be assigned to, and where they will appear within the Services Hub.",

    // Interventions
    INTERVENTIONS: "Interventions",
    NO: "No",
    ACTIVITY_TYPE: "Activity Type",
    TIME_OF_DAY: "Time of Day",
    ACTIVITY_DESCRIPTION: "Activity Description",
    PARENT_ACTIVITY: "Parent Activity",
    VIDEO: "Video?",
    PARENT_ABSENCE_REASON: "Parent Absence Reason",
    TOTAL_ACTIVITIES: "Total Activities:",
    ADD_CARE_PLAN: "Add Care Plan",
    EDIT_CARE_PLAN_WITH_ID: "Edit Care Plan ID {id}",
    ADD_ACTIVITY: "Add Activity",
    EDIT_ACTIVITY: "Edit Activity",
    GUIDANCE: "Guidance",
    DAY_NUMBER: "Day Number",
    DEFAULT_GUIDANCE: "Default Guidance",
    DISPLAY_IMAGE: "Display Image",
    SAFETY_CRITICAL: "Safety Critical",
    WORKING_OUTSIDE: "Working Outside",
    DSE_ADVICE: "DSE Advice",
    STATIONARY_WORKING: "Stationary Working",
    LIFTING_AND_CARRYING: "Lifting & Carrying",
    WORKING_AT_WORKS: "Working at Heights",
    HIGH_PRESSURE_WORKING: "High Pressure Working",
    ADD_TRIAGE_QUESTION: "Add Triage Question",
    EDIT_TRIAGE_QUESTION_WITH_ID: "Edit Triage Question ID {id}",
    ADD_TRIAGE_ADVICE: "Add Triage Advice",
    EDIT_TRIAGE_ADVICE_WITH_ID: "Edit Triage Advice ID {id}",
    ADVICE_ID: "Advice ID",
    ADVICE_TEXT: "Advice Text",
    FIRST_QUESTION: "First Question",
    FOLLOW_UP_QUESTION: "Follow-Up Question",
    RED_FLAG: "Red Flag?",
    CARE_PLANS: "Care Plans",
    SUPPORT_PLANS: "Support Plans",
    TRIAGE_ADVICE: "Symptom Advice",
    TRIAGE_QUESTIONS: "Triage Questions",
    CARE_PLANS_INFO:
      "Care Plans are shown to employees in the GoodShape app and are created based on the Parent Absence Reason of an absence. A Care Plan can include 6 different types of activity: Rest, Hydration, Food, Care, Mind and Physical. Any changes to these plans only affect new absences.",
    SUPPORT_PLANS_INFO:
      "Support Plans are created once an employee has closed their absence. Their purpose is to help support the employee for up to 2 weeks after their return-to-work, and help them to avoid issues that could cause a re-occurrence of their absence.",
    TRIAGE_ADVICE_INFO:
      "This is the pre-written advice made available for the clinical team to select during the Advice step of the Triage Assessment process in GoodShapeHealth. The purpose of the pre-written advice is to save the Nurses time by allowing them to select advice given, instead of needing to write it all from scratch.",
    TRIAGE_QUESTIONS_INFO:
      "These are the questions that appear in the Red Flag Triage Assessment within GoodShape Health, and are used by GoodShape nurses when completing callbacks. Any changes will only affect new triage assessments that are completed after the changes have been saved.",
    CARE_PLANS_NO_RESULTS_MESSAGE:
      "This absence reason does not have a dedicated care plan currently. Instead, the default, generic care plan is used.",
  },
};
